<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-cogs">
      <translate>Shipment Task Hooks</translate>
    </page-title>

    <api-list type="shippingTaskHooks" :model="models.shippingTaskHooks" hideFilters :page-options="[1, 5, 10, 25, 50, 100, 150]" />
    <!-- :quick-filters="quickFiltersSetup.shippingTaskHooksFilters" -->

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ShippingTaskHooksList',
  title() {
    return this.$gettext('Shipment Task Hooks')
  },
  components: {
    ApiList
  },
  props: {
    type: {
      type: String,
      default: 'shippingTaskHooks'
    }
  }
}
</script>
